<div
  class="flex h-14 flex-row items-center overflow-clip border-0 border-b-2 border-zinc-700 bg-zinc-500 px-2 shadow md:px-0"
>
  <ng-content></ng-content>
</div>
